/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Share_Modal_Link_LabelInputs */

const es_chat_share_modal_link_label = /** @type {(inputs: Chat_Share_Modal_Link_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enlace para compartir`)
};

const en_chat_share_modal_link_label = /** @type {(inputs: Chat_Share_Modal_Link_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share link`)
};

/**
* | output |
* | --- |
* | "Share link" |
*
* @param {Chat_Share_Modal_Link_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_share_modal_link_label = /** @type {((inputs?: Chat_Share_Modal_Link_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Share_Modal_Link_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_share_modal_link_label(inputs)
	return en_chat_share_modal_link_label(inputs)
});
export { chat_share_modal_link_label as "chat.share_modal.link_label" }